<template>
    <base-form v-bind="{ ...settings }" >
        <component
            :is="input"
            class="gocc__authentication__form__field"
            :settings="{
                label: { class: 'field__label--hide', text: $t('global.email') },
                input: {
                    component: 'InputBasic',
                    id: 'email',
                    name: 'email',
                    type: 'text',
                    class: 'gocc__authentication__form__field__input',
                    value: '',
                    placeholder: $t('global.email'),
                    browserAutocomplete: 'email',
                    isRequired: true,
                    fileValidation: 'basicEmail',
                    errors: [{
                        type: 'email', warning: $t('error.email')
                    }],
                    isMissing: errors.missing.email,
                    noListener: true
                },
                allowFilling: true
            }"
        />
        <base-password
            :input="input"
            class="gocc__authentication__form__field"
            :settings="{
                label: { class: 'field__label--hide', text: $t('global.password') },
                input: {
                    name: 'password',
                    class: 'gocc__authentication__form__field__input',
                    placeholder: $t('global.password'),
                    fileValidation: null,
                    browserAutocomplete: 'current-password',
                    isMissing: errors.missing.password,
                    noListener: true
                }
            }"
        />
        <router-link
            to="/authentication/forgot"
            activeClass="active"
            class="gocc__authentication__form__anchor display--block color--green capitalize"
        >
            {{ $t('authentication.forgotPassword') }}
        </router-link>
        <submission-handler>
            <component
                :is="button"
                type="submit"
                class="gocc__authentication__form__button background--green color--white"
                v-html="$t('global.entry')"
            />
        </submission-handler>
    </base-form>
</template>

<script>
// store
import { mapState } from '@/hooks/use-store';

// hooks
import { authenticationStructure } from '@/hooks/use-data';

export default {
    ...authenticationStructure,
    setup () {
        const errors = mapState({ module: 'storePayload', key: 'errors' });

        return { errors };
    }
};
</script>